import axios from '../index'

export default {
    getInstitucion (params) {
        return axios.get('/instituciones/usuario/', {
            params
        })
    },
    getCiclosEscolares (institucionId) {
        return axios.get('/ciclos-escolares/ciclosPorInstitucion/'+ institucionId)
    },
    getPrograma (institucionId) {
        return axios.get('/programas/directiva/'+ institucionId)
    },
    getGrupo (institucionId, params){
        return axios.get('/grupos-administrativos/gruposInstitucion/' + institucionId, {
            params
        })
    },
    getEstatusAlumno(params){
        return axios.get('/api/status',{params})
    },
    getPermisosSeccion (params) {
        return axios.get('/api/v1/personas/permisos', {
            params
        })
    },
    getCodigoDetalle (){
        return axios.get('/reportesMovimientos/getCodigosDetalleCargos')
    },
    getCodigoDetallePagos (){
        return axios.get('/reportesMovimientos/getCodigosDetallePagos')
    },
    getFuenteMovimientos(){
        return axios.get('/reportesMovimientos/getFuentesMovimientosPagos')
    },
    getFuenteMovimientosCargos(){
        return axios.get('/reportesMovimientos/getFuentesMovimientosCargos')
    },
    getMetodosPagosIngresos(){
        return axios.get('/reportesMovimientos/getMetodosPagosIngresos')
    },
    getReporteIngresos(params){
        return axios.post('/reportesMovimientos/getIngresos', params)
    },
    getReporteCargos(params){
        return axios.get('/reportesMovimientos/getCargos', {
            params
        })
    },
    getExcel(){
        return axios.get('reportes/file-ingresos')
    },
    getProgramas(alumnos) {
        return axios.get('/api/v1/programas/persona',{params: alumnos})
    },
    restablecerGenerarCargos(alumnos){
        return axios.post('/generacion-de-cargos/masivos',{alumnos})
    },
    getActualizarSaldos (alumnos) {
        return axios.post('/aplicacion-de-pagos/masivos', {alumnos})
    },
    getInfoPendientes(params){
        return axios.get('/reportesMovimientos/getDinamicReport', {
            params
        })
    },
    getGenerarCargos(alumnos){
        return axios.post('/generacion-de-cargos/masivos',{alumnos})
    },
    getEnviarCartas(params){
        return axios.post('/api/reportes-movimientos/enviar-notificacion', params)
    },
    //CONCILIACIÓN
    getInfoConciliacion(params){
        return axios.get('/api/v1/conciliacion/getReportConciliaciones', {
            params
        })
    },
    getConciliar(pagos, tipo){
        return axios.post('/api/v1/personas/registrar-pago',{pagos, tipo})
    },
    getStatus(){
        return axios.get('/api/v1/tip-banamex/estatus')
    },
    getArchivosConciliacion(params){
        return axios.get('/api/v1/conciliacion/banamex/getFiles', {params})
    },

    //FACTURACIÓN
    getConceptos(){
        return axios.get('/api/v1/cobranza/listado/pagos')
    },
    getCFDI(){
        return axios.get('/api/v1/facturacion/directiva/estatus')
    },
    getTipoFactura(){
        return axios.get('/api/v1/facturacion/directiva/tipo')
    },
    getFuente(){
        return axios.get('/api/v1/fuentes-de-movimiento/directiva')
    },
    getCodigoDetalle(){
        return axios.get('/api/v1/cobranza/listado/cargos')
    },
    getDescargar(persona, id_concepto , type) {
        return axios.post('/api/v1/cobranza/facturacion/' + persona + '/persona/' + id_concepto + '/pago/' + type + '/extension/descargar', {
            responseType: 'blob'
        })
    },
    getInfoFacturas(params){
        return axios.get('/api/v1/reportes/facturacion/filtrar', {params})
    },
    getFacturaTemp(personaId, id , tipo,uuid, params) {
        return axios.get('/estado-de-cuenta/facturacion/'+ personaId + '/persona/' + id + '/movimiento/' + tipo + '/tipo/factura/' + uuid, {
            responseType: 'blob',
            params: params,
        })
    },
    postCancelarFacturaMasiva(payload){
        return axios.post('/api/facturacion/cancelacion-masiva', payload)
    },
    // CALIFICACIONES
    getGrupoAcademico(params){
        return axios.get('/reportes-academicos/getGruposAcademicos', {params})
    },
    getPeriodoCalificaciones(params){
        return axios.get('/reportes-academicos/getPeriodos', {params})
    },
    getPeriodoCalculados(params){
        return axios.get('/reportes-academicos/getPeriodosCalculados', {params})
    },
    getInfoCalificaciones(params){
        return axios.get('/reportes-academicos/getReporteCalificaciones', {params})
    },

    // DESCARGA BOLETA

    getInfoBoletas(params){
        return axios.get('/alumno-calificaciones/getAlumnosParaBoletaMasiva', {params})
    },
    getDescargarBoletas(params){
        return axios.get('/alumno-calificaciones/getCalificacionesPorAlumnos', {params})
    },
    getObservaciones(params){
        return axios.get('/docente-observaciones/getObservacionesPorAlumnos', {params})
    },

    // GRUPOS ACADEMICOS
    getGruposAcademicos(params){
        return axios.get('/reportes-academicos/getAlumnosPorGrupoAcademico', {params})
    },
    getInfoGrupoAcademico(params, isntitucion){
        return axios.get('/bloques-crns/catalogo/' + isntitucion, {params})
    },
    getDocentesGrupoAcademico(institucion){
        return axios.get('/docentes/porInstitucionId/' + institucion)
    },
    getEliminarGrupoAcademico(params){
        return axios.get('/reportes-academicos/deleteRegistroAcademicoOnCrn/',{params})
    },

    // ACADEMICO
    getGradoAcademico(programa){
        return axios.get('/atributos/porPrograma/' + programa)
    },

    // CARTERA VENCIDA
    getCarteraVencida(params){
        return axios.get('/reportes/paginate-cartera-vencida', {params})
    },

    //PROSPECTOS
    getProspectos(params){
        return axios.get('/reportes/paginate-prospectos', {params})
    },
    // getFileProspectos(params){
    //     return axios.get('/file-prospectos', {params})
    // },

    // ACCESOS ALUMNOS
    getAccesoAlumnos(params){
        return axios.get('/reportes/paginate-accesos', {params})
    },

    // ACCESOS PERSONAS
    getAccesoPersonas(params){
        return axios.get('/reportes/paginate-accesos-personas', {params})
    },

    // ALUMNOS INSCRITOS
    getStatusAlumnosInscritos(){
        return axios.get('/reportes/status')
    },
    getAlumnosInscritos(params){
        return axios.get('/reportes/paginate-alumnos-por-ciclo', {params})
    },

    // BECAS
    getReporteBecas(params){
        return axios.get('/reportes/paginate-becas', {params})
    },

    // SEGUIMIENTO COBRANZA E INSCRIPCION
    getSeguimientoInscripcion(params){
        return axios.get('/reportes-academicos/getSeguimientoCobranzaAlumnosPorGrupoAcademico', {params})
    },

    // ACTUALIZACIÓN DE DOCUMENTOS DIGITALES
    getActualizacionDocumentos(params){
        return axios.get('/expedienteDigital/getDocumentosPorGrupoAdmin', {params})
    },

    // FOTOGRAFIAS MASIVAS ALUMNOS
    getFotografiasMasivas(params){
        return axios.get('/imagenesMasivas/getPersonasAvatares', {params})
    },

    // MONITOR DE CALIFICACIONES 
    getMonitorCalificaciones(params){
        return axios.get('/reportes-academicos/monitorCalificacionesDocentes', {params})
    },
    getFechaLimite(idConfiguracion){
        return axios.get('/api/rest/ConfiguracionEvaluaciones/' + idConfiguracion)
    },
    postEnviarCorreoProfesores(params){
        return axios.post('/api/reportes-academicos/captura-calificaciones-mail', params)
    },

    // DATOS FISCALES 
    getDatosFiscales(params){
        return axios.get('/reportesFiscales/getDatosFiscales', {params})
    },

    // SALDOS INICIALES 
    getRegistrarCarteraVencida(params){
        return axios.get('/api/v1/cobranza/registroCargoManual', {params})
    },
    getCicloAnterior(institucion){
        return axios.get('/ciclos-escolares/show/' + institucion)
    },

    //BECAS APLICADAS
    getBecasAplicadas(params){
        return axios.post('/reportesMovimientos/getBecas', params)
    },

    //HORARIOS
    getReporteHoriarios(params){
        return axios.post('/reportesMovimientos/getBecas', params)
    },

    //FINANZAS SIM
    getFinanzasSim(params){
        return axios.get('/sim/getAlumnoFinanzas', {params})
    },

}
